import { TooltipProps } from './types';
import { StyledHugeTooltip } from './style';
import { EProductType } from 'utils/enums';
import { useEffect, useState } from 'react';

function Tooltip({
  rarityText,
  stars,
  quantityDisplay,
  tooltipText,
  display,
  productIndex,
  customPositioning,
  customStyles,
}: TooltipProps) {
  return (
    <StyledHugeTooltip
      display={display ? 'flex' : 'none'}
      bottomPosition={
        !productIndex ? 'unset' : productIndex % 2 === 0 ? '50%' : '5px'
      }
      transformValue={!productIndex ? 'unset' : 'translateY(100%)'}
      positionValue={customPositioning ? 'relative' : 'absolute'}
      style={customStyles}
    >
      <h3>{quantityDisplay}</h3>
      <h4 className="tooltip-content">
        {rarityText}{' '}
        {Array.from({ length: stars }, (_, i) => {
          return (
            <img
              src="https://media.appcharge.com/media/641026dc506b12bf96a88368/star.png"
              alt="star"
              key={i}
            />
          );
        })}
      </h4>
      <p>{tooltipText}</p>
    </StyledHugeTooltip>
  );
}

export default Tooltip;
